export enum Language {
    FA = 'FA',
}
